import { useEffect, useState } from "react";

/**
 * Debounce a changing value (e.g. search input).
 *
 * @param {string|number|boolean|Object|Array} value - The value to debounce
 * @param {number} [delayMs=300] - Debounce delay in milliseconds
 * @returns {string|number|boolean|Object|Array} The debounced value
 */
export function useDebounce(value, delayMs = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => clearTimeout(timeoutId);
  }, [value, delayMs]);

  return debouncedValue;
}

